import { render, staticRenderFns } from "./Tutoria.vue?vue&type=template&id=718e8022&"
import script from "./Tutoria.vue?vue&type=script&lang=js&"
export * from "./Tutoria.vue?vue&type=script&lang=js&"
import style0 from "./Tutoria.vue?vue&type=style&index=0&id=718e8022&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports